import styled from "styled-components"

export const PostHeroBlogHEADER = styled.header`
  padding: 0 0 var(--spacing--L);

  h1 {
    text-align: center;
    max-width: max(837px, calc((var(--container-width) / 12 * 8) - (var(--spacing--M) * 4 / 12)));
    margin: 0 auto .5em;
    text-wrap: balance;
  }
`
